import MainLayout from 'components/layout/main';
import { useFacilityPageTitle } from './lib/hooks/useFacilityPageProps';
import useFacilityBreadcrumbs from 'utils/hooks/breadcrumbs/useFacilityBreadcrumbs';
import MainInfoFacility from './components/mainInfo';
import { Role } from 'generated/graphql';
import { useMeRole } from 'store/hooks/useMeRole';
import FacilityAccess from './components/facilityAccess';
import { Form, Formik } from 'formik';
import { useFacilityPageForm } from './lib/hooks/useFacility2PageForm';
import { useParentObjects } from './lib/hooks/useParentObjects';
import useFacilityHeaderMenu from 'utils/hooks/headerMenu/useFacilityHeaderMenu';
import FacilityMedicalInvoice from './components/facilityMedicalInvoice';
import FacilityPenalty from './components/facilityPenalty';
import { useParams } from 'react-router';
import PromotionBlock from './components/promotionBlock';
import FacilityForemenSupervisors from './components/facilityResponsibility/ForemanSupervisor';
import ManagersAndDirectorsBlock from './components/facilityResponsibility/ManagersAndDirectorsBlock';

const UpdateFacility2 = () => {
  const { facilityId } = useParams();
  const isMeAdmin = useMeRole([Role.Admin]);

  const title = useFacilityPageTitle();
  const headerMenu = useFacilityHeaderMenu();
  const breadCrumbs = useFacilityBreadcrumbs();

  const { initialValues, validate, onSubmit, checkTimesheetInheritance, isLoadingCreate } = useFacilityPageForm();
  const { parentObjects, handleSearch, handleScroll } = useParentObjects();

  const handleParentObjectChange = (value: string, setFieldValue: (field: string, value: any) => void) => {
    setFieldValue('parentFacilityId', value);

    if (value && parentObjects) {
      const isInherited = checkTimesheetInheritance(parentObjects, value);
      setFieldValue('isTimesheetInherited', isInherited);
      if (isInherited) {
        setFieldValue('showTimesheet', false);
      }
    } else {
      setFieldValue('isTimesheetInherited', false);
    }
  };

  return (
    <MainLayout title={title} headerMenu={headerMenu} breadCrumbs={breadCrumbs}>
      <Formik enableReinitialize initialValues={initialValues} validate={validate} onSubmit={onSubmit}>
        {({ values, setFieldValue, touched, errors, handleChange }) => (
          <>
            <div className="grid grid-cols-12 md:gap-x-6 gap-y-6">
              <Form className="col-span-full grid grid-cols-12 md:gap-x-6 gap-y-6">
                <div className="col-span-full xl:col-span-9 md:col-span-7">
                  <div className="facilityPageBlock blockTemplate">
                    <MainInfoFacility
                      values={values}
                      touched={touched}
                      errors={errors}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      onParentObjectChange={value => handleParentObjectChange(value, setFieldValue)}
                      parentObjects={parentObjects}
                      onParentObjectSearch={handleSearch}
                      onParentObjectScroll={handleScroll}
                      isLoadingCreate={isLoadingCreate}
                    />
                  </div>
                </div>
                {isMeAdmin && <FacilityAccess values={values} setFieldValue={setFieldValue} />}
              </Form>
            </div>

            {!!facilityId && (
              <div className="grid grid-cols-12 md:gap-x-6 gap-y-6 mt-6">
                <ManagersAndDirectorsBlock />
                <FacilityForemenSupervisors />
                <PromotionBlock />
                <FacilityPenalty />
                <FacilityMedicalInvoice />
              </div>
            )}
          </>
        )}
      </Formik>
    </MainLayout>
  );
};

export default UpdateFacility2;
